import { TechDocsSearch } from '@backstage/plugin-techdocs';
import { useEntity } from '@backstage/plugin-catalog-react';

import { TechDocsActionsMenu } from './TechDocsActionsMenu';
import { TechDocsVersionSelector } from './TechDocsVersionSelector';

const SIDE_COLUMN_WIDTH = 150;

export const RdapTechDocsToolbar = () => {
  const { entity } = useEntity();

  const entityId = {
    kind: entity.kind,
    namespace: entity.metadata.namespace ?? 'default',
    name: entity.metadata.name,
  };

  return (
    <div
      className="rdap-techdocs-toolbar"
      style={{
        display: 'grid',
        gridTemplateColumns: `${SIDE_COLUMN_WIDTH}px 1fr ${SIDE_COLUMN_WIDTH}px`,
        alignItems: 'center',
        width: '100%',
        gap: 8,
        padding: '8px 24px',
        boxSizing: 'border-box',
        fontSize: '1.05rem',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TechDocsVersionSelector />
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 480 }}>
          <TechDocsSearch
            entityId={entityId}
            entityTitle={entity.metadata.title}
          />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <TechDocsActionsMenu />
      </div>
    </div>
  );
};
